import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Typography, makeStyles, Container, Menu } from '@material-ui/core';
import cx from 'classnames';
import AccountPopover from '../growz/AccountPopover';
import MenuItems from '../../components/common/growz/MenuItems';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import FooterMain from '../components/Footer.jsx';
import { useSelector } from 'react-redux';
import Helpiconprimary from '../../assets/images/helpiconprimary.svg';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { _route } from '../../utils';
import WestIcon from '@mui/icons-material/West';

const useStyles = makeStyles({
  breadcrumb_sm: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    marginBottom: '0',
    color: 'rgb(0 0 0 / 60%)',
  },
  BackButton: {
    display: 'flex',
    padding: '6px 8px 6px 8px',
    marginRight: '8px',
    cursor: 'pointer',
    borderRadius: '8px',
    alignItems: 'center',
    transition: '.3s',
    '&:hover': {
      background: '#e4e4e4',
      transition: '.3s',
    },
  },
  breadcrumb_main: {
    margin: 0,
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '38px',
    color: '#101828',
    display: '-webkit-box',
    overflow: 'hidden',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': '1',
    textOverflow: 'ellipsis',
    letterSpacing: '-0.016em',
  },
  breadcrumb_svg: {
    marginLeft: '6px',
    verticalAlign: 'middle',
  },
  header_menu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '26px',
    padding: '1px 35px',
    background: '#fff',
    borderBottom: '1px solid rgba(194, 178, 178, 0.35)',
    top: '0',
    position: 'sticky',
    left: '0',
    zIndex: 99,
  },
  header_custom_menu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1px 35px',
    background: '#fff',
    borderBottom: '1px solid rgba(194, 178, 178, 0.35)',
    top: '0',
    position: 'sticky',
    left: '0',
    zIndex: 99,
  },
  header_menu_back: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1px 35px',
    background: '#fff',
    borderBottom: '1px solid rgba(194, 178, 178, 0.35)',
    marginBottom: '26px',
    top: '0',
    position: 'sticky',
    left: '0',
    zIndex: 99,
  },
  header_menu_right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tooltip_heading: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '18px',
    margin: '0 0 4px 0',
    textAlign: 'left',
    color: '#fff',
  },
  tooltip_description: {
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'left',
    color: 'rgb(255 255 255 / 90%)',
    whiteSpace: 'normal',
    margin: '6px 0 6px 0',
  },
  smText: {
    opacity: '.8',
    verticalAlign: 'middle',
    marginRight: '6px',
  },
  header_regions: {
    marginRight: '24px',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
  },
  tooltip_learn_more: {
    textDecoration: 'underline',
    textAlign: 'left',
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
    color: '#c6ccff',
  },
  tooltip_learn_more_svg: {
    color: '#c6ccff',
    fontSize: '16px',
    marginLeft: '2px',
    transform: 'rotate(320deg)',
  },
  containerStore: {
    borderRadius: '0!important',
    padding: '0!important',
    paddingRight: '0!important',
  },
  contentHolder: {
    paddingLeft: '35px',
    paddingRight: '35px',
  },
});

const Page = ({
  title,
  heading,
  children,
  back,
  description,
  learnMore,
  customHeaderWidget,
  showFooter = true,
  customStyles = {},
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { pathname, key } = useLocation();
  const realm = useSelector(({ auth }) => auth.realm);
  const profile = useSelector(({ auth }) => auth.store.profile);
  const [anchorEl, setAnchorEl] = useState(null);

  function handleClick(event) {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const allStyles = { minHeight: 'calc(100vh - 120px)', maxWidth: '100%', ...customStyles };

  const goToPreviousPath = (e) => {
    e.preventDefault();

    history.goBack();
  };

  const allowedRoutes = [
    _route('growz.overview'),
    _route('aisle.intro'),
    _route('account.profile', { realm }),
    _route('account.changePassword', { realm }),
    _route('account.notification', { realm }),
  ];

  if (!(profile || realm === 'stores') && !allowedRoutes.includes(pathname)) {
    if (realm.includes('aisle')) {
      return <Redirect to={_route(`${realm}.intro`)} />;
    } else {
      return <Redirect to={_route(`${realm}.overview`)} />;
    }
  }

  return (
    <>
      <Container maxWidth="lg" style={allStyles} className={classes.containerStore}>
        <div className={cx('lg_screen')}>
          {title && (
            <Helmet>
              <title>{title}</title>
            </Helmet>
          )}
          {heading && (
            <>
              <div
                className={
                  customHeaderWidget ? classes.header_custom_menu : back ? classes.header_menu_back : classes.header_menu
                }
              >
                <div className="flexCenter" style={{ alignItems: 'center' }}>
                  {back && history.length > 1 && key && (
                    <div className={classes.BackButton} onClick={goToPreviousPath}>
                      <WestIcon style={{ width: '24px', height: '24px' }} />
                    </div>
                  )}
                  {heading && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography className={classes.breadcrumb_main}>{heading}</Typography>
                      {description && (
                        <div>
                          <div
                            aria-owns={anchorEl ? 'simple-menu' : undefined}
                            aria-haspopup="true"
                            onClick={handleClick}
                            onMouseOver={handleClick}
                            style={{ display: 'flex' }}
                          >
                            <img src={Helpiconprimary} className={classes.breadcrumb_svg} />
                          </div>
                          <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            MenuListProps={{ onMouseLeave: handleClose }}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'bottom',
                            }}
                            transformOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left',
                            }}
                            className="tooltipList"
                          >
                            <div className="cardShadowPopupsDark" style={{ borderRadius: '8px', width: '300px' }}>
                              <Typography variant="h6" className={classes.tooltip_heading}>
                                {heading}
                              </Typography>
                              <Typography variant="body2" className={classes.tooltip_description}>
                                {description}
                              </Typography>
                              {learnMore && (
                                <a
                                  href={learnMore}
                                  style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Typography variant="body2" className={classes.tooltip_learn_more}>
                                    Learn more
                                  </Typography>
                                  <ArrowForwardIcon className={classes.tooltip_learn_more_svg} />
                                </a>
                              )}
                            </div>
                          </Menu>
                        </div>
                      )}
                    </div>
                  )}
                  {/* {mainHeading && <Typography className={classes.breadcrumb_sm}>{mainHeading}</Typography>} */}
                </div>
                <div className={classes.header_menu_right}>
                  <div className={classes.header_regions}>{realm !== 'stores' && <MenuItems />}</div>

                  <div className="headerAccount">
                    <AccountPopover />
                  </div>
                </div>
              </div>
              <div>{customHeaderWidget}</div>
            </>
          )}

          <div className={classes.contentHolder}>{children}</div>
          {showFooter && <FooterMain />}
        </div>
      </Container>
    </>
  );
};
Page.propTypes = {
  title: PropTypes.string.isRequired,
  heading: PropTypes.string,
  mainHeading: PropTypes.string,
  children: PropTypes.node,
};

Page.defaultProps = {
  heading: null,
  mainHeading: null,
};

export default Page;
